import React, { useEffect, useState } from "react";
import z from "zod"
import Template from "../../../layout/Template";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { UsuariosService } from "../../../services/api/Usuarios/UsuariosService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../components/Loader/Loading"
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal";
import { usePermissoes } from "../../../hooks/usePermissoes";
import PermissoesComponent from "../../../components/PermissaoComponent";

const UsuariosCadEdit = () => {


    const schema = z.object({
        name: z.string().min(3, "O nome deve ter no mínimo 3 letras"),
        password: z.coerce.string().nullable(),
        confirmPassword: z.coerce.string().nullable(),
        email: z.coerce.string().email('E-mail inválido'),
        alteraSenha: z.coerce.string().nullable(),
        foto: z.any().nullable(),
    }).refine((data) =>
    (data.alteraSenha.toString() == '1' && data.password == data.confirmPassword
        || data.alteraSenha.toString() == '0')
        , {
            message: 'As senhas não iguais!',
            path: ['password']
        })

    const navigate = useNavigate();
    const [usuario, setUsuario] = useState(null)
    const { idUsuario } = useParams()
    const [showSenha, setShowSenha] = useState(false);
    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(schema),
        values: usuario
    })
    const watchAlteraSenha = watch('alteraSenha')
    const watchFoto = watch('foto')
    const [imgFoto, setImgFoto] = useState(null)
    const [disableSalvar, setDisableSalvar] = useState(false)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 7, acoesId: 1 },
        { secoesId: 7, acoesId: 2 },
    ])


    useEffect(() => {

        const fetchUsuarios = async () => {
            setIsloading(true);
            const data = await UsuariosService.getById(idUsuario)

            if (data.success) {

                let userData = data.data
                setUsuario({
                    ...userData,
                    alteraSenha: "0",
                    name: userData.nome,
                    foto: null
                })

                setImgFoto(userData.foto)


            }

            setIsloading(false);
        }
        if (idUsuario != null) {
            fetchUsuarios(idUsuario);
        } else {
            setIsloading(false);
            setUsuario({
                ...usuario,
                alteraSenha: "1"
            })
        }
    }, [])

    useEffect(() => {
        if (watchAlteraSenha === "0") {
            setShowSenha(false)
        } else {
            setShowSenha(true)
        }

    }, [watchAlteraSenha])

    useEffect(() => {


        if (watchFoto != undefined) {
            if (watchFoto.length > 0) {
                const teste = URL.createObjectURL(watchFoto[0])
                setImgFoto(teste)
            }


        }
    }, [watchFoto])

    const clearFoto = () => {
        if (imgFoto != null) {
            URL.revokeObjectURL(imgFoto)
        }
    }


    const onSubmit = async (dados) => {

        setDisableSalvar(true)


        let formData = new FormData();

        console.log(dados)
        if (dados.foto != null) {
            formData.append("foto", dados.foto[0]);
        }


        formData.append("name", dados.name)
        formData.append("password", dados.password)
        formData.append("email", dados.email)
        formData.append("alteraSenha", dados.alteraSenha)


        let dataForm = dados;
        delete dataForm.confirmPassword;



        if (idUsuario == null) {
            const user = await UsuariosService.store(formData);
            if (user.data.success) {
                clearFoto() //limpando a memoria
                navigate('/admin/configuracoes/usuarios/')
            } else {
                alert(user.data.msg)
                setDisableSalvar(false)
            }

        } else {


            const user = await UsuariosService.updateById(idUsuario, formData);
            if (user.data.success) {
                clearFoto() //limpando a memoria
                navigate('/admin/configuracoes/usuarios/')
            } else {
                setDisableSalvar(false)
            }

        }
    }


    return (
        <>
            <ConfiguracoesSistemaPrincipal>
                <Container fluid>
                    <h4 className="text-info">Usuário - {(idUsuario != null) ? 'Editar' : 'Cadastrar'}</h4>
                    <hr></hr>



                    {(isLoading) ? <Loading /> : (
                        <>
                            {(
                                (!listPermissoes?.cadastrar && !isLoadingPerm && idUsuario == null)
                                || (!listPermissoes?.editar && !isLoadingPerm && idUsuario != null)
                            ) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                                <>
                                    <Form>
                                        <Row className="mb-10">

                                            <Form.Group as={Col} sm={5} >
                                                <img src={imgFoto} style={{ maxWidth: '150px' }} />
                                            </Form.Group>
                                        </Row>
                                        <br></br>
                                        <Row className="mb-10">
                                            <Form.Group as={Col} sm={4}>
                                                <Form.Label>Inserir/Alterar foto:</Form.Label>
                                                <Form.Control type="file" accept="image/png, image/gif, image/jpeg"
                                                    {...register('foto')}
                                                ></Form.Control>

                                            </Form.Group>

                                        </Row>



                                        <Row className="mb-10">
                                            <Form.Group as={Col} sm={4}>
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control type="text" placeholder="Nome"
                                                    {...register('name')}
                                                    isInvalid={!!(errors?.name)}
                                                ></Form.Control>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.name?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} sm={4}>
                                                <Form.Label>E-mail</Form.Label>
                                                <Form.Control type="email" placeholder="E-mail"
                                                    isInvalid={!!(errors?.email)}
                                                    {...register('email')}
                                                ></Form.Control>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.email?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            <Form.Group as={Col} sm={6}>
                                                <Form.Label className="mr-10">Alterar senha?</Form.Label>
                                                <Form.Check
                                                    inline
                                                    type="radio"
                                                    label="Não"
                                                    value="0"
                                                    {...register('alteraSenha')}
                                                ></Form.Check>

                                                <Form.Check
                                                    inline
                                                    type="radio"
                                                    label="Sim"
                                                    value="1"
                                                    {...register('alteraSenha')}
                                                ></Form.Check>
                                            </Form.Group>
                                        </Row>
                                        <Row style={{ display: (showSenha) ? '' : 'none' }}>
                                            <Form.Group as={Col} sm={4}>
                                                <Form.Label>Senha</Form.Label>
                                                <Form.Control type="password"
                                                    {...register('password')}
                                                    isInvalid={!!(errors?.password)}
                                                ></Form.Control>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.password?.message}
                                                </Form.Control.Feedback>

                                            </Form.Group>

                                            <Form.Group as={Col} sm={4}>
                                                <Form.Label>Confirmar senha</Form.Label>
                                                <Form.Control type="password"
                                                    {...register('confirmPassword')}
                                                    isInvalid={!!(errors?.confirmPassword)}
                                                ></Form.Control>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.confirmPassword?.message}
                                                </Form.Control.Feedback>

                                            </Form.Group>
                                        </Row>

                                        <div className="text-center">
                                            <Button variant="danger" size="sm" className="mr-10" href={'/admin/configuracoes/usuarios'}>Cancelar</Button>
                                            <Button variant="primary" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                                {(disableSalvar) ? <>
                                                    <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Salvando...
                                                </> : 'Salvar'}</Button>

                                        </div>
                                    </Form>
                                </>)}

                        </>)}

                </Container>


            </ConfiguracoesSistemaPrincipal>


        </>
    )


}

export default UsuariosCadEdit